import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { User, Zap, Target, Users } from "lucide-react";
import { aboutMe, personalInfo } from "../../data/mock";

const AboutSection = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  const highlightIcons = [Zap, Target, Users, User];

  return (
    <section id="about" className="py-24 sm:py-32 relative" ref={ref} aria-label="About Aditya Aman">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <span className="text-sm font-semibold text-[rgb(218,255,1)] uppercase tracking-widest">
            About Me
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mt-3 tracking-tight">
            Passionate about building
            <br />
            <span className="text-[rgb(218,255,1)]">scalable solutions</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left - Description */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="text-lg text-[rgb(218,218,218)] leading-relaxed mb-8">
              {aboutMe.description}
            </p>
            <p className="text-[rgb(161,161,170)] leading-relaxed">
              I specialize in the MERN stack and love working on challenging problems
              that push the boundaries of web development. From real-time streaming
              platforms to complex enterprise applications, I bring a holistic approach
              to every project.
            </p>
          </motion.div>

          {/* Right - Highlights grid */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="grid grid-cols-2 gap-4"
          >
            {aboutMe.highlights.map((highlight, index) => {
              const Icon = highlightIcons[index];
              return (
                <div
                  key={index}
                  className="group p-5 rounded-2xl bg-[rgb(26,28,30)] border border-[rgba(255,255,255,0.1)] hover:border-[rgb(218,255,1)] hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-[rgba(218,255,1,0.1)] flex items-center justify-center mb-3 group-hover:bg-[rgba(218,255,1,0.2)] transition-colors duration-300">
                    <Icon size={20} className="text-[rgb(218,255,1)]" />
                  </div>
                  <p className="text-sm font-medium text-white">{highlight}</p>
                </div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
